module.exports = __webpack_public_path__ + "static/media/icn-claim.85aa9621.svg";